import React, { Component } from 'react';
import Study from '../studies/Study';

class Studies extends Component {
  render() {
    return (
    <div className="page" id={this.props.id}>
        <div className="page-container">
            <h2>Studies</h2>

            <Study 
            title="Bachelor's degree in Game Development" 
            description="Gaming Campus" 
            info="Top of the class"
            link="https://gamingcampus.fr"
            location="Lyon | France" 
            date="2022 - 2023"
            />

            <Study 
            title="Bachelor's degree in Computer Science" 
            description="Faculté des Sciences et Technologies" 
            link="https://fst.univ-lorraine.fr"
            location="Nancy | France" 
            date="2021 - 2022"
            />

            <Study 
            title="Diplome Universitaire de Technologie (DUT) in Computer Science" 
            description="IUT Nancy-Charlemagne" 
            link="https://iut-charlemagne.univ-lorraine.fr"
            location="Nancy | France" 
            date="2019 - 2021"
            />

        </div>
    </div>
    );
  }
}

export default Studies;